import { c as _c } from "react/compiler-runtime";
import { APPROVE_WAVE_TAB_LABEL_MAX_LENGTH, DEFAULT_APPROVE_WAVE_TAB_LABELS, getEffectiveApproveWaveTabLabels } from "@/helpers/waves/wave-metadata.helpers";
import type { CreateWaveApproveDisplayConfig } from "@/types/waves.types";
import WaveSettingEditorActions from "./WaveSettingEditorActions";
type ApproveTabLabelField = "approvals" | "approved";
interface WaveApproveTabLabelsEditorFormProps {
  readonly disabled: boolean;
  readonly display: CreateWaveApproveDisplayConfig;
  readonly errorMessage: string | null;
  readonly field: ApproveTabLabelField;
  readonly onCancel: () => void;
  readonly onDisplayChange: (display: CreateWaveApproveDisplayConfig) => void;
  readonly onSave: () => void;
  readonly onUseDefault: () => void;
  readonly saveDisabled: boolean;
}
const FIELD_CONFIG: Record<ApproveTabLabelField, {
  readonly ariaLabel: string;
  readonly draftKey: keyof CreateWaveApproveDisplayConfig;
  readonly label: string;
  readonly placeholder: string;
}> = {
  approvals: {
    ariaLabel: "Approvals tab label",
    draftKey: "approvalsTabLabel",
    label: "Approvals tab label",
    placeholder: DEFAULT_APPROVE_WAVE_TAB_LABELS.approvals
  },
  approved: {
    ariaLabel: "Approved tab label",
    draftKey: "approvedTabLabel",
    label: "Approved tab label",
    placeholder: DEFAULT_APPROVE_WAVE_TAB_LABELS.approved
  }
};
export default function WaveApproveTabLabelsEditorForm(t0) {
  const $ = _c(44);
  const {
    disabled,
    display,
    errorMessage,
    field,
    onCancel,
    onDisplayChange,
    onSave,
    onUseDefault,
    saveDisabled
  } = t0;
  let t1;
  if ($[0] !== display) {
    t1 = getEffectiveApproveWaveTabLabels(display);
    $[0] = display;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const labels = t1;
  const fieldConfig = FIELD_CONFIG[field];
  const value = display[fieldConfig.draftKey];
  const useDefaultDisabled = value.length === 0;
  const inputClasses = `tw-min-w-0 tw-rounded-md tw-border tw-border-solid tw-bg-iron-900 tw-px-2.5 tw-py-2 tw-text-sm tw-text-iron-100 focus:tw-outline-none ${errorMessage ? "tw-border-error focus:tw-border-error" : "tw-border-iron-700 focus:tw-border-primary-400"}`;
  let t2;
  if ($[2] !== onSave) {
    t2 = event => {
      event.preventDefault();
      onSave();
    };
    $[2] = onSave;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== fieldConfig.label) {
    t3 = <span>{fieldConfig.label}</span>;
    $[4] = fieldConfig.label;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== display || $[7] !== field || $[8] !== onDisplayChange) {
    t4 = event_0 => {
      const nextValue = event_0.target.value;
      onDisplayChange(field === "approvals" ? {
        ...display,
        approvalsTabLabel: nextValue
      } : {
        ...display,
        approvedTabLabel: nextValue
      });
    };
    $[6] = display;
    $[7] = field;
    $[8] = onDisplayChange;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== disabled || $[11] !== fieldConfig.ariaLabel || $[12] !== fieldConfig.placeholder || $[13] !== inputClasses || $[14] !== t4 || $[15] !== value) {
    t5 = <input aria-label={fieldConfig.ariaLabel} autoComplete="off" autoFocus={true} className={inputClasses} disabled={disabled} maxLength={APPROVE_WAVE_TAB_LABEL_MAX_LENGTH} placeholder={fieldConfig.placeholder} type="text" value={value} onChange={t4} />;
    $[10] = disabled;
    $[11] = fieldConfig.ariaLabel;
    $[12] = fieldConfig.placeholder;
    $[13] = inputClasses;
    $[14] = t4;
    $[15] = value;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== t3 || $[18] !== t5) {
    t6 = <label className="tw-flex tw-flex-col tw-gap-1.5 tw-text-sm tw-font-medium tw-text-iron-100">{t3}{t5}</label>;
    $[17] = t3;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span className="tw-rounded-md tw-bg-iron-900 tw-px-2 tw-py-1">Chat</span>;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== labels.approvals) {
    t8 = <span className="tw-rounded-md tw-bg-iron-800 tw-px-2 tw-py-1 tw-text-iron-200">{labels.approvals}</span>;
    $[21] = labels.approvals;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== labels.approved) {
    t9 = <span className="tw-rounded-md tw-bg-iron-800 tw-px-2 tw-py-1 tw-text-iron-200">{labels.approved}</span>;
    $[23] = labels.approved;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t8 || $[26] !== t9) {
    t10 = <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-1.5 tw-text-xs tw-font-semibold tw-text-iron-400">{t7}{t8}{t9}</div>;
    $[25] = t8;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== errorMessage) {
    t11 = errorMessage ? <p className="tw-mb-0 tw-text-xs tw-leading-5 tw-text-error">{errorMessage}</p> : null;
    $[28] = errorMessage;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== onUseDefault || $[31] !== useDefaultDisabled) {
    t12 = {
      disabled: useDefaultDisabled,
      label: "Use default",
      onClick: onUseDefault,
      variant: "neutral"
    };
    $[30] = onUseDefault;
    $[31] = useDefaultDisabled;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  let t13;
  if ($[33] !== disabled || $[34] !== onCancel || $[35] !== saveDisabled || $[36] !== t12) {
    t13 = <WaveSettingEditorActions disabled={disabled} onCancel={onCancel} secondaryAction={t12} submitDisabled={saveDisabled} />;
    $[33] = disabled;
    $[34] = onCancel;
    $[35] = saveDisabled;
    $[36] = t12;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  let t14;
  if ($[38] !== t10 || $[39] !== t11 || $[40] !== t13 || $[41] !== t2 || $[42] !== t6) {
    t14 = <form className="tw-flex tw-flex-col tw-gap-3" onSubmit={t2}>{t6}{t10}{t11}{t13}</form>;
    $[38] = t10;
    $[39] = t11;
    $[40] = t13;
    $[41] = t2;
    $[42] = t6;
    $[43] = t14;
  } else {
    t14 = $[43];
  }
  return t14;
}
export type { ApproveTabLabelField };